import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import "./AboutSchool.css";

const AboutSchool = (props) => {
  return (
    <div className="container-fluid background-white">
      <div className="container container-background">
        <div className="row">
          <div className="col-lg-6 col-12 d-flex justify-content-center align-items-center position-relative overflow-hidden">
            <img
              src={props.main_image}
              alt="main"
              className="school-images m-5 p-0"
            />
            <img
              src={props.secondary_image}
              alt="secondary"
              className="school-images d-none d-sm-block "
            />
          </div>
          <div className="col-lg-6 col-12 p-5">
            <div className="left-border mb-3">
              <h3>{props.small_title}</h3>
              <h2>{props.main_title}</h2>
            </div>
            <BlocksRenderer
              content={Array.isArray(props.text) ? props.text : []}
            ></BlocksRenderer>
            <div className="d-flex justify-content-center justify-content-md-end">
              {props.link && <Link to={props.link.Odkaz}>
                <Button text={props.link.Text} />
              </Link>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AboutSchool;
